import request from '@/utils/request'

// 根据产品品牌产品线获取产品品类
export function getCategoryByBrandLineName(data) {
  return request({
    url: '/orderCommon/getCategoryByBrandLineName',
    method: 'get',
    params: data
  })
}

// 获取厂家产品品牌
export function getFactoryBrand(data) {
  return request({
    url: '/orderCommon/getFactoryBrand',
    method: 'get',
    params: data
  })
}

// 获取厂家产品线
export function getFactoryProductLine(data) {
  return request({
    url: '/orderCommon/getFactoryProductLine',
    method: 'get',
    params: data
  })
}

// 根据条件获取产品型号
export function getModelByCondition(data) {
  return request({
    url: '/orderCommon/getModelByCondition',
    method: 'get',
    params: data
  })
}

// 选择型号带出相关品牌、品类
export function distinguishModel(data) {
  return request({
    url: '/orderCommon/distinguishModel',
    method: 'get',
    params: data
  })
}

// 根据物流单号获取物流名称
export function getExpressName(code) {
  return request({
    url: '/orderCommon/getExpressName/'+code,
    method: 'get',
  })
}

// 工单详情里面的服务要求
export function getByProductLineName(data) {
  return request({
    url: '/orderCommon/getByProductLineName',
    method: 'get',
    params: data
  })
}

// 查询物流信息
export function getLogicalDetail(data) {
  return request({
    url: '/orderCommon/getLogicalDetailNew',
    method: 'get',
    params: data
  })
}

// 无效原因下拉
export function getInvalidType() {
  return request({
    url: '/orderCommon/invalidReasonSelect',
    method: 'get',
  })
}

// 费用列表
export function feeApplicationList(query) {
  return request({
    url: '/order/orderFeeApplication/feeApplicationList',
    method: 'get',
    params: query
  })
}

// 申请费用/修改费用
export function saveFeeApplication(data) {
  return request({
    url: '/order/orderFeeApplication/saveFeeApplication',
    method: 'post',
    data: data
  })
}

// 编辑费用时获取费用详情
export function applicationFeeDetail(query) {
  return request({
    url: '/order/orderFeeApplication/applicationFeeDetail',
    method: 'get',
    params: query
  })
}

// 删除-费用申请记录
export function deleteFeeAppliction(query) {
  return request({
    url: '/order/orderFeeApplication/deleteFeeApplication',
    method: 'get',
    params: query
  })
}

// 撤回-费用申请审核
export function feeApplicationBack(query) {
  return request({
    url: '/order/orderFeeApplication/feeApplicationBack',
    method: 'get',
    params: query
  })
}

// 审核通过
export function auditFeeApplication(query) {
  return request({
    url: '/order/orderFeeApplication/auditFeeApplication',
    method: 'get',
    params: query
  })
}

// 待审核菜单-审核(获取页面的金额)
export function getOrderAuditFee(query) {
  return request({
    url: '/order/orderFeeApplication/getOrderAuditFee',
    method: 'get',
    params: query
  })
}

// 厂家待结算-结算页面--获取审核的金额
export function getAuditSettleCost(query) {
  return request({
    url: '/order/orderFeeApplication/getAuditSettleCost',
    method: 'get',
    params: query
  })
}







